import {MDCTabBar} from '@material/tab-bar';

import {attachAllAccountMenus} from './ui/accountmenu';
import {attachAllProfileCards} from './ui/profilecard';

/* Legacy hamburger drawer (#id_lb-primary-nav-drawer) was removed in
   favor of the universal account-pill popover (see
   frontend/ts/ui/accountmenu.ts + listblox/templates/_account_menu.html).
   The dashboard/admin in-page tab bar still uses MDCTabBar where it
   exists; this wires that up defensively. */

attachAllAccountMenus();
attachAllProfileCards();

const tabBar = document.querySelector('.mdc-tab-bar');
if (tabBar) {
	new MDCTabBar(tabBar as HTMLElement);
}
